export default "__VITE_ASSET__DkR5rLED__"